// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Container_wrapper__IWY85","wide":"Container_wide__1KznT","slim":"Container_slim___cSAk"};